<script setup>

const colorMode = useColorMode()

const props = defineProps({
	loading: {
    type: Boolean,
		default: false
  },
	smallGrid: {
		type: Boolean,
		default: false
	}
})

</script>

<template>
	<div
		class="load-more cursor-pointer flex relative justify-center items-center"
		:class="[smallGrid ? 'mt-6 xl:mt-10' : 'mt-10 xl:mt-20']"
	>
		<!-- <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none">
			<circle opacity="0.8" cx="35" cy="35" r="33.5" :stroke="colorMode.preference === 'dark' ? 'white' : '#1D1D1B'" stroke-width="3"/>
			<path d="M22 32L42 32" stroke="#F5F5F5" stroke-width="3"/>
			<path d="M32 22L32 42" stroke="#F5F5F5" stroke-width="3"/>
		</svg> -->
		<ClientOnly>
			<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
				<circle cx="32" cy="32" r="30.5" :stroke="colorMode.preference === 'dark' ? 'white' : '#1D1D1B'" stroke-width="3"/>
				<path v-if="!loading" d="M22 32L42 32" :stroke="colorMode.preference === 'dark' ? 'white' : '#1D1D1B'" stroke-width="3"/>
				<path v-if="!loading" d="M32 22L32 42" :stroke="colorMode.preference === 'dark' ? 'white' : '#1D1D1B'" stroke-width="3"/>
			</svg>
			<Loader v-if="loading" class="loader" />
		</ClientOnly>
	</div>
</template>

<style lang="scss" scoped>

	.loader {
		position: absolute;
		top: 0;
		transform: scale(0.7) translateY(-24px);
	}

	svg {
		transition: 0.2s;
	}

	.load-more {

		&:hover {
			svg {
				transform: scale(1.1);
			}
		}
	}

</style>